import { render } from "./MemoruPurchaseHistory.vue?vue&type=template&id=50082d6e&ts=true"
import script from "./MemoruPurchaseHistory.vue?vue&type=script&lang=ts"
export * from "./MemoruPurchaseHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__